const states = {
    entity_details: {
        entities: [],
        entity_types: ['simple', 'hierarchical', 'list'],
        active_entity_data: {},



        
        list_entity: {
            entity: {},
            utterances: [],
        },


        
        loaders: {
            entities_loading: false,
            entities_loaded: false,
            entity_creating: false,
            entity_data_loading: false,
            entity_data_loaded: false,
            entity_updating: false,
        },
    },
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/entity_details/states.js